import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'

import { menu2routes } from '@/utils'
import { getMenuData } from '../api/login'

// 懒加载方式
const Login = () => import('views/login')
const NotFound = () => import('views/404')
const Layout = () => import('components/content/layout')

import asyncRoutes from '@/router/routes.js'

Vue.use(VueRouter)

// 所有权限通用路由表
export const constRoutes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登录'
    }
  },
  {
    // 404页面
    path: '/404',
    name: '404',
    component: NotFound,
    meta: {
      title: '抱歉，页面未找到'
    }
  },
]


const notFoundRoute = [{
    // 未配置路由的页面都重定向到404,必须加在最后面
    path: '*',
    redirect: '/404',
}]

// 实例化 router 时只挂载constRoutes
const createRouter = () => new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: constRoutes
})

const router = createRouter()

// 根据 menu 动态加载路由
newRouter()

// 导航守卫
// 注册一个全局前置守卫
router.beforeEach((to, from, next) => {
  // 路由变化时修改页面title
  if (to.meta.name) {
    document.title = to.meta.name
  }

  // 判断用户是否登录
  let token = store.state.user.authorization;
  if (to.path === '/login') {
    // 路由指向登录页面，正常去登录
    next()
  } else {
    if (to.matched.length === 0) {
      newRouter()
    }
    // 路由不是指向登录页面，需要判断token是否存在
    // if (typeof(token) == 'undefined' || token === 'null' || token === null || token === '') {
    if (!token) {
      document.title = '登录'
      next('/login')
    } else {
      next()
    }
  }
})

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export function newRouter() {
  if (store.state.user.menu) {
    const newRoutes = menu2routes(store.state.user.menu)
    let remote=asyncRoutes['/remote'];
    remote.meta={
      icon:'',
      name:'远程接管',
      path:'/remote',
    };
    newRoutes.push(remote)
    const route = {
      path: '/',
      component: Layout,
      redirect: '/index',
      children: newRoutes
    }
    // router.addRoutes(newRoutes)
    router.addRoutes([route])
    router.addRoutes(notFoundRoute)
  }
}

export default router
